import { VStack } from '@chakra-ui/react';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import { useCallback } from 'react';

const PageContainer = ({ children }) => {
  const particlesInit = useCallback(async engine => {
    console.log(engine);
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async container => {
    await console.log(container);
  }, []);
  return (
    <VStack
      minH={'100vh'}
      minW={'100vw'}
      padding={{ base: '18px', md: '2vw' }}
      backgroundColor={'#10111d'}
      color={'rgba(255,255,255,0.88)'}
      align={'stretch'}
      spacing={0}
      overflowX={'hidden'}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: '#10111d',
            },
          },
          fpsLimit: 30,
          interactivity: {
            events: {
              onClick: {
                enable: false,
                mode: 'push',
              },
              onHover: {
                enable: true,
                mode: 'repulse',
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 150,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: '#8B5CF6',
            },
            links: {
              color: '#8B5CF6',
              distance: 150,
              enable: true,
              opacity: 0.28,
              width: 1,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: {
                default: 'bounce',
              },
              random: false,
              speed: 1,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 50,
            },
            opacity: {
              value: 0.42,
            },
            shape: {
              type: 'triangle',
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
        }}
      />
      {children}
    </VStack>
  );
};

export default PageContainer;
